var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFollow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.165,
    height: 14.992,
    viewBox: "0 0 21.165 14.992",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2000",
    "data-name": "Group 2000",
    transform: "translate(0.539 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_160",
    "data-name": "Path 160",
    d: "M6217.24,10032.455s-.444-4.591,1.581-7.262a8.662,8.662,0,0,1,3.754-3.081c4.019-1.566,8.579.26,8.579.26v-3.908l6.171,6.169-6.171,6.17v-3.69s-4.239-1.916-8-.559S6217.24,10032.455,6217.24,10032.455Z",
    transform: "translate(-6217.199 -10018.464)",
    fill: "none",
    stroke: "#373334",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFollow);
export default __webpack_public_path__ + "static/media/follow.f84c4b41e3bbfee9fa3b185216a0dc0c.svg";
export { ForwardRef as ReactComponent };